export default {"src":"/_next/static/media/bfc logo.2eb5cd74.svg","height":85,"width":189,"blurWidth":0,"blurHeight":0};